module.exports = __webpack_public_path__ + "static/media/Recipe_Spotlight.1d3b07e8.jpg";